import React, { Component } from "react";
import withAuth from "./../auth_components/js/withAuth";
import Navbar from "../Components/Navbar";
import { GetData } from "../api/service";
import { LinearProgress, Typography } from "@material-ui/core";
import DepartmentalProfile from "../Components/Department/DepartmentalProfile";
import DepartmentHomePage from "../Components/Department/DepartmentHomePage";
import DepartmentGlance from "../Components/Department/DepartmentGlance";
import DepartmentCourses from "../Components/Department/DepartmentCourses";
import DepartmentFiles from "../Components/Department/DepartmentFiles";
import Gallery from "../Components/Gallery/Gallery";
import DepartmentContact from "../Components/Department/DepartmentContact";
import DepartmentFaculty from "../Components/Department/DepartmentFaculty";

class DepartmentHomeLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      active: 0,
      isDeptLoaded: false,
      dept_code: "",
    };
  }

  getDeptCodeFromRole = (props = this.props) => {
    if (
      !props.user ||
      !props.user.user ||
      !props.user.user.role
    ) {
      return "";
    }

    const role = String(props.user.user.role).toUpperCase();
    if (role === "FACULTY") {
      return "";
    }

    return role;
  };

  getDeptCodeFromParams = (props = this.props) => {
    if (!props.match || !props.match.params || !props.match.params.dept_code) {
      return "";
    }

    return String(props.match.params.dept_code).toUpperCase();
  };

  resolveDeptCode = (props = this.props) => {
    return this.getDeptCodeFromParams(props) || this.getDeptCodeFromRole(props);
  };

  __getDeptData = (dept_code) => {
    GetData(`/admin/${dept_code}/getsingledeptdata`)
      .then((resp) => {
        if (resp != false) {
          this.setState({
            data: resp,
            active: dept_code == "OFF" ? 7 : 0,
            isDeptLoaded: true,
            dept_code,
          });
        } else {
          this.setState({
            data: {},
            active: dept_code == "OFF" ? 7 : 0,
            isDeptLoaded: true,
            dept_code,
          });
        }
      })
      .catch(() => {
        this.setState({
          data: {},
          active: dept_code == "OFF" ? 7 : 0,
          isDeptLoaded: true,
          dept_code,
        });
      });
  };

  loadDepartmentData = (props = this.props) => {
    const dept_code = this.resolveDeptCode(props);

    if (dept_code !== "") {
      this.setState({ isDeptLoaded: false }, () => {
        this.__getDeptData(dept_code);
      });
      return;
    }

    this.setState({
      data: {},
      active: 0,
      isDeptLoaded: true,
      dept_code: "",
    });
  };

  componentDidMount() {
    this.loadDepartmentData();

    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const user = storedUser.user || {};

    this.setState({
      apikey: user.apikey || "",
      username: user.username || "",
    });
  }

  componentDidUpdate(prevProps) {
    const previousDeptCode = this.resolveDeptCode(prevProps);
    const currentDeptCode = this.resolveDeptCode(this.props);

    if (previousDeptCode !== currentDeptCode) {
      this.loadDepartmentData(this.props);
    }
  }

  render() {
    const linkType =
      this.props.match && this.props.match.params
        ? this.props.match.params.link
        : "";

    return (
      <div>
        <Navbar history={this.props.history} />
        <div className="main-body">
          {!this.state.isDeptLoaded ? (
            <LinearProgress color="secondary" />
          ) : null}

          <div
            style={{
              marginBottom: 20,
              backgroundColor: "white",
              padding: 20,
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2)",
              borderRadius: 10,
            }}
          >
            <Typography variant="h6">{linkType.toUpperCase()}</Typography>
            <Typography variant="body2">
              Department Code: {this.state.dept_code || "N/A"}
            </Typography>
            
          </div>

          {this.state.isDeptLoaded && linkType === "profile" && (
            <div>
              <DepartmentalProfile
                data={this.state.data}
                dept_code={this.state.dept_code}
              />
            </div>
          )}

          {this.state.isDeptLoaded && linkType === "banner" && (
            <div>
              <DepartmentHomePage {...this.state.data} {...this.props} />
            </div>
          )}

          {this.state.isDeptLoaded && linkType === "glance" && (
            <div>
              <DepartmentGlance {...this.state.data} {...this.props} />
            </div>
          )}

           {this.state.isDeptLoaded && linkType === "courses" && (
            <div>
              <DepartmentCourses {...this.state.data} {...this.props} />
            </div>
          )}

          {this.state.isDeptLoaded && linkType === "syllabus" && (
            <div>
              <DepartmentFiles {...this.state.data} {...this.props} type="SYLLABUS" />
            </div>
          )}

          {this.state.isDeptLoaded && linkType === "journal" && (
            <div>
              <DepartmentFiles {...this.state.data} {...this.props} type="JOURNAL" />
            </div>
          )}

          {this.state.isDeptLoaded && linkType === "achievements" && (
            <div>
              <DepartmentFiles {...this.state.data} {...this.props} type="ACHIEVEMENTS" />
            </div>
          )}
          {this.state.isDeptLoaded && linkType === "co-po" && (
            <div>
              <DepartmentFiles {...this.state.data} {...this.props} type="CO_PO" />
            </div>
          )}

          {this.state.isDeptLoaded && linkType === "contact" && (
            <div>
              <DepartmentContact {...this.state.data} {...this.props} />
            </div>
          )}
          {this.state.isDeptLoaded && linkType === "faculty" && (
            <div>
              <DepartmentFaculty {...this.state.data} {...this.props} />
            </div>
          )}
           {this.state.isDeptLoaded && linkType === "gallery" && (
            <div>
              <Gallery
                   
                        type="DEPARTMENT"
                    
                        dept={this.state.data.dept_code}
                        history={this.props.history}
                        apikey={this.state.apikey}
                        username={this.state.username}
                    />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withAuth(DepartmentHomeLanding);



// WEBPACK FOOTER //
// ./src/Containers/DepartmentHomeLanding.js